"use strict";
/*
 * Copyright (c) 2018 - Present, Vamstar Limited
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or
 * without modification, are not permitted.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.getCountryByName = exports.getCountryNameByCode = void 0;
const country_1 = require("../constants/country");
const constants_1 = require("./constants");
function getCountryNameByCode(code) {
    const country = country_1.countries.find((item) => item.code === code);
    return country ? country.name : '';
}
exports.getCountryNameByCode = getCountryNameByCode;
const getCountryByName = (name) => {
    const CANARY_ISLAND_NAME = 'Canary Islands';
    const CANARY_ISLAND_CODE = 'ES';
    if (name.toLowerCase() === CANARY_ISLAND_NAME.toLowerCase()) {
        return { name: CANARY_ISLAND_CODE, code: CANARY_ISLAND_CODE };
    }
    const country = country_1.countries.find(c => c.name.toLowerCase() === name.toLowerCase()) || constants_1.DEFAULT_COUNTRY;
    return country;
};
exports.getCountryByName = getCountryByName;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiY291bnRyeS11dGlscy5qcyIsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIi4uLy4uL3NyYy91dGlscy9jb3VudHJ5LXV0aWxzLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7QUFBQTs7Ozs7O0dBTUc7OztBQUlILGtEQUFpRDtBQUNqRCwyQ0FBOEM7QUFFOUMsU0FBZ0Isb0JBQW9CLENBQUMsSUFBWTtJQUMvQyxNQUFNLE9BQU8sR0FBRyxtQkFBUyxDQUFDLElBQUksQ0FBQyxDQUFDLElBQVMsRUFBRSxFQUFFLENBQUMsSUFBSSxDQUFDLElBQUksS0FBSyxJQUFJLENBQUMsQ0FBQztJQUNsRSxPQUFPLE9BQU8sQ0FBQyxDQUFDLENBQUMsT0FBTyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDO0FBQ3JDLENBQUM7QUFIRCxvREFHQztBQUVNLE1BQU0sZ0JBQWdCLEdBQUcsQ0FBQyxJQUFZLEVBQVksRUFBRTtJQUN6RCxNQUFNLGtCQUFrQixHQUFHLGdCQUFnQixDQUFDO0lBQzVDLE1BQU0sa0JBQWtCLEdBQUcsSUFBSSxDQUFDO0lBQ2hDLElBQUksSUFBSSxDQUFDLFdBQVcsRUFBRSxLQUFLLGtCQUFrQixDQUFDLFdBQVcsRUFBRSxFQUFFO1FBQzNELE9BQU8sRUFBRSxJQUFJLEVBQUUsa0JBQWtCLEVBQUUsSUFBSSxFQUFFLGtCQUFrQixFQUFFLENBQUM7S0FDL0Q7SUFFRCxNQUFNLE9BQU8sR0FBRyxtQkFBUyxDQUFDLElBQUksQ0FBQyxDQUFDLENBQUMsRUFBRSxDQUFDLENBQUMsQ0FBQyxJQUFJLENBQUMsV0FBVyxFQUFFLEtBQUssSUFBSSxDQUFDLFdBQVcsRUFBRSxDQUFDLElBQUksMkJBQWUsQ0FBQztJQUNwRyxPQUFPLE9BQU8sQ0FBQztBQUNqQixDQUFDLENBQUM7QUFUVyxRQUFBLGdCQUFnQixvQkFTM0IifQ==